(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-bar"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.search-bar__disclosure').forEach((disclosure) => {
    const toggle = disclosure.querySelector('.search-bar__toggle');
    const input = disclosure.querySelector('input[type="search"]');

    function isOpen() {
      return disclosure.classList.contains('search-bar__disclosure--open');
    }

    function open() {
      disclosure.classList.add('search-bar__disclosure--open');
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => input && input.focus());
    }

    function close() {
      disclosure.classList.remove('search-bar__disclosure--open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', () => (isOpen() ? close() : open()));

    disclosure.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') close();
    });

    disclosure.addEventListener('focusout', () => {
      setTimeout(() => {
        if (isOpen() && !disclosure.contains(document.activeElement)) close();
      });
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !disclosure.contains(event.target)) close();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
